module.exports = __webpack_public_path__ + "img/lazer.e80f460a.svg";